import React from 'react';

const Option = ({ value, text }) => {
  return (
    <option key={value} value={value}>
      {text}
    </option>
  );
};

Option.defaultProps = {};
Option.propTypes = {};

export default Option;
